var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "结算详情",
            visible: _vm.visible,
            "close-on-click-model": false,
            "append-to-body": "",
            fullscreen: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            close: _vm.dialogClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "name_group" },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    size: "small",
                    clearable: "",
                    placeholder: "订单号",
                  },
                  on: { change: _vm.searchDetail },
                  model: {
                    value: _vm.activeProjectId,
                    callback: function ($$v) {
                      _vm.activeProjectId = $$v
                    },
                    expression: "activeProjectId",
                  },
                },
                _vm._l(_vm.settleOption, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.id },
                  })
                }),
                1
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    icon: "el-icon-download",
                    size: "small",
                    type: "primary",
                  },
                  on: { click: _vm.exportShow },
                },
                [_vm._v("导出")]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "audit-info" }, [
            _vm._v(
              "\n      起草人： " +
                _vm._s(_vm.activePorject.adduser || "-") +
                "（" +
                _vm._s(_vm.activePorject.addtime) +
                "）审核人：" +
                _vm._s(_vm.activePorject.checkuser || "-") +
                " （" +
                _vm._s(_vm.activePorject.checktime) +
                "） 审核说明： " +
                _vm._s(_vm.activePorject.checkmsg) +
                "\n    "
            ),
          ]),
          _c("project-detail-table", {
            attrs: {
              projectInfo: _vm.activePorject,
              monthData: _vm.monthData,
              orderTableData: _vm.monthTableData,
            },
          }),
          _c("exportDialog", {
            attrs: {
              exportDailogFlag: _vm.showExport,
              projectInfo: _vm.activePorject,
              projectId: _vm.activeProjectId,
            },
            on: {
              "update:exportDailogFlag": function ($event) {
                _vm.showExport = $event
              },
              "update:export-dailog-flag": function ($event) {
                _vm.showExport = $event
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }